<template>
    <div class="row">
        <div class="col-12 mb-1">
            <v-file-uploader :accept="['xls','xlsx']" :value="value" value-parameter="File"></v-file-uploader>
        </div>
        <div class="col-12">
            <b-form-checkbox v-model="value.Kesinti">Kesintileri nete dahil et</b-form-checkbox>    
        </div>
    </div>
</template>

<script>
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'
import { BFormCheckbox } from 'bootstrap-vue'

export default {
    components:{
        VFileUploader,
        BFormCheckbox
    },
    props:{
        value:Object,
        donem:Object,
        uploadingPayroll:Boolean,
        uploadingTicket:Boolean,
        ticketErrors:Array
    }
}
</script>

<style>

</style>